import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'

type TopbarProps = {
  setContentContainerRef: (el: HTMLDivElement | null) => void
  rightPanelWidth?: number
}

export function Topbar(props: TopbarProps) {
  const { setContentContainerRef, rightPanelWidth = 0 } = props
  return (
    <AppBar
      position="fixed"
      sx={{
        pl: '34px',
        pr: '34px',
        // Match the desktop content column so the fixed bar cannot cover ELARA's controls.
        width: { xs: '100%', md: `calc(100% - ${rightPanelWidth}px)` },
        right: { xs: 0, md: rightPanelWidth },
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar disableGutters ref={setContentContainerRef}></Toolbar>
    </AppBar>
  )
}

export default Topbar
